import { useTranslation } from "react-i18next";
import { useCachedResource } from "../hooks/useCachedResource";
import { acctAudit } from "../api/accounting";
import { AcctShell } from "../features/acct/AcctShell";
import { NeuCard } from "../components/neu/Neu";
import { localDateTime } from "../lib/datetime";

export default function AcctAuditPage() {
  const { t } = useTranslation();
  const { data } = useCachedResource("acct-audit", () => acctAudit().catch(() => []));
  const rows = data || [];

  return (
    <AcctShell titleKey="audit">
      <NeuCard className="overflow-x-auto p-4" data-testid="acct-audit">
        {rows.length === 0 ? (
          <p className="py-6 text-center text-sm text-muted-foreground" data-testid="acct-audit-empty">
            {t("acct.auditEmpty")}
          </p>
        ) : (
          <table className="w-full min-w-[640px] text-sm">
            <thead>
              <tr className="text-start text-[11px] uppercase text-muted-foreground">
                {["auditAt", "auditActor", "auditAction", "auditTarget"].map((k) => (
                  <th key={k} className="px-2 py-2 text-start">{t(`acct.${k}`)}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-border/50">
              {rows.map((r) => (
                <tr key={r.id} data-testid={`audit-row-${r.id}`}>
                  <td className="px-2 py-2 font-mono text-xs">{localDateTime(r.at)}</td>
                  <td className="px-2 py-2">{r.actor_email || "—"}</td>
                  <td className="px-2 py-2 font-semibold text-primary">{r.action}</td>
                  <td className="px-2 py-2 font-mono text-xs">{r.target || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </NeuCard>
    </AcctShell>
  );
}
